import { useModal, create, show } from "@ebay/nice-modal-react";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";
import { Scan } from "types/generated";

import { SCAN_DELETE } from "../../useScans/gql";

type DeleteConfirmationProps = {
  name: string;
  id: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  name,
  id,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deleteScan, { loading, data }] = useMutation<{
    scanDelete: Scan | null;
  }>(SCAN_DELETE, {
    refetchQueries: ["SearchScans", "SearchScansCount"],
    awaitRefetchQueries: true,
    variables: { id },
  });

  const handleDelete = useCallback(() => {
    deleteScan()
      .then(() => {
        reportSuccess({
          message: "Scan successfully deleted",
        });
        modal.resolve();
        modal.hide();
      })
      .catch(onError);
  }, [deleteScan, modal, onError, reportSuccess]);

  return (
    <DeleteConfirmationModal
      title="Delete scan"
      name={name}
      onConfirm={handleDelete}
      isLoading={loading}
      isDismissable={!loading && !data?.scanDelete?.id}
    />
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
